//interface for columns
import { ColumnMeta } from "./interfaces";

// crop Columns
export const CropColumns: ColumnMeta[] = [
  { field: "crop_name", header: "Name" },
  // { field: "n_from_to_to", header: "N From - TO" },
  // { field: "p_from_to_to", header: "P From - TO" },
  // { field: "k_from_to_to", header: "K From - TO" },
  // { field: "ph_from_to_to", header: "PH From - TO" },
  { field: "action", header: "Action" },
];

// equipment Columns
export const EquipmentColumns: ColumnMeta[] = [
  { field: "equipment_name", header: "Name" },
  { field: "status", header: "Status" },
  { field: "action", header: "Action" },
];

// spray for problem Columns
export const SprayProblemColumns: ColumnMeta[] = [
  { field: "problem_name", header: "Problem Name" },
  { field: "status", header: "Status" },
  { field: "action", header: "Action" },
];

// money received column
export const moneyReceivedCol: ColumnMeta[] = [
  { field: "received_amount", header: "Received Amount" },
  { field: "received_date", header: "Received Date" },
];

//service list column
export const serviceListColumn: ColumnMeta[] = [
  { field: "photo", header: "Image" },
  { field: "service_name", header: "Name" },
  { field: "price", header: "Price" },
  { field: "operator_price", header: "Operator Price" },
  { field: "description", header: "Description" },
  { field: "type_of_equipment", header: "Types of Equipments" },
  { field: "price_on", header: "Price On" },
  { field: "action", header: "Action" },
];

//operator list column
export const operatorListColumn: ColumnMeta[] = [
  // { field: "profile_img", header: "Operator Image" },
  { field: "name", header: "Name" },
  { field: "email", header: "Email" },
  { field: "mobile", header: "Mobile no" },
  { field: "type_of_equipment", header: "Equipments" },
  { field: "status", header: "Status" },
  { field: "action", header: "Action" },
];

// booking list col
export const bookingListCol: ColumnMeta[] = [
  { field: "farmer_name", header: "Farmer Name" },
  { field: "mobile", header: "Mobile" },
  { field: "service_name", header: "Service Name" },
  { field: "total_farm", header: "Total Farm" },
  { field: "booking_date", header: "Booking Date" },
  // { field: "time_slot_data", header: "Slot" },
  { field: "total_amount", header: "Total Amount" },
  { field: "transaction", header: "Transaction" },
  { field: "booking_status", header: "Status" },
  { field: "operator_name", header: "Operator Name" },
  { field: "action", header: "Action" },
];

//service list column
export const serviceItemListColumn: ColumnMeta[] = [
  { field: "item_type", header: "Type" },
  { field: "item_name", header: "Name" },
  { field: "item_price", header: "Price" },
  { field: "action", header: "Action" },
];

// Booking Slots Columns
export const BookingSlotsColumns: ColumnMeta[] = [
  { field: "slot", header: "Slots" },
  { field: "start_time", header: "Start Time" },
  { field: "end_time", header: "End Time" },
  { field: "action", header: "Action" },
];

// Farmer List Columns
export const FarmerListColumns: ColumnMeta[] = [
  { field: "name", header: "Farmer Name" },
  { field: "mobile", header: "Mobile" },
  { field: "email", header: "Email" },
  { field: "createdAt", header: "Date" },
  { field: "wallet_points", header: "Wallet Points" },
  { field: "is_soilsense_added", header: "Added In SoilSense" },
  { field: "add_points", header: "Add Points" },
  { field: "action", header: "Action" },
];

// Farmer List Columns
export const AnnuounceListColumns: ColumnMeta[] = [
  { field: "name", header: "Farmer Name" },
  { field: "mobile", header: "Mobile" },
  { field: "email", header: "Email" },
  { field: "total_area", header: "Total Area" },
  { field: "wallet_points", header: "Wallet Points" }
];

// Farm List Columns
export const FarmListColumns: ColumnMeta[] = [
  { field: "farm_name", header: "Farm Name" },
  { field: "land_area", header: "Land Area" },
  { field: "crop_id", header: "Crop" },
  // { field: "location", header: "location" },
  // { field: "survey_number", header: "Survey Number" },
  { field: "address", header: "Address" },
];

// Farmer Booking list Columns
export const FarmerBookingListColumns: ColumnMeta[] = [
  { field: "operator_name", header: "Operator Name" },
  { field: "service_name", header: "Service Name" },
  { field: "total_farm", header: "Total Farm" },
  { field: "booking_date", header: "Booking Date" },
  // { field: "time_slot_data", header: "Slot" },
  { field: "total_amount", header: "Total Amount" },
  { field: "transaction", header: "Transaction" },
  { field: "booking_status", header: "Status" },
  { field: "action", header: "Action" },
];

// Farmer Booking list Columns
export const OperatorBookingListColumns: ColumnMeta[] = [
  { field: "farmer_name", header: "Farmer Name" },
  { field: "farm_name", header: "Farm Name" },
  { field: "service_name", header: "Service Name" },
  { field: "crop_name", header: "Crop" },
  { field: "time_slot_data", header: "Slot" },
  { field: "total_amount", header: "Total Amount" },
  { field: "booking_status", header: "Status" },
  { field: "action", header: "Action" },
];

// global data column
export const globalDataCol: ColumnMeta[] = [
  { field: "is_online_wallet_enable", header: "Online Wallet Status" },
  {
    field: "is_transaction_wallet_enable",
    header: "Transaction Wallet Status",
  },
];


// Farmer List Columns
export const FTCPartnerListColumns: ColumnMeta[] = [
  { field: "name", header: "Partner Name" },
  { field: "mobile", header: "Mobile" },
  { field: "email", header: "Email" },
  { field: "businessName", header: "Business Name" },
  { field: "experience", header: "Experience (Years)" },
  { field: "landSize", header: "Land Size" }
];

// Operator Report Columns
export const operatorReportColumns: ColumnMeta[] = [
  { field: "booking_id", header: "Booking ID" },
  { field: "booking_date", header: "Booking Date" },
  { field: "farmer_name", header: "Farmer Name" },
  { field: "farmer_mobile", header: "Farmer Mobile" },
  { field: "operator_name", header: "Operator Name" },
  { field: "booking_status", header: "Booking Status" },
  { field: "operator_charge", header: "Operator Charge" },
  { field: "farmer_village", header: "Village" },
  { field: "farmer_taluka", header: "Taluka" },
  { field: "farmer_district", header: "District" },
  { field: "farm_name", header: "Farm Name" },
  { field: "crop", header: "Crop" },
  { field: "crop_age", header: "Crop Age" },
  { field: "area_of_acre", header: "Area (Acre)" },
  { field: "spray_for_problem", header: "Spray For Problem" },
  { field: "spray_type", header: "Spray Type" },
  { field: "used_products", header: "Used Products" },
  { field: "amount_transaction", header: "Transaction" },
  { field: "payment_method", header: "Payment Method" },
  { field: "amount_paid", header: "Amount Paid" },
  { field: "payment_status", header: "Payment Status" },
  { field: "before_spray_image", header: "Before Spray" },
  { field: "after_spray_image", header: "After Spray" },
  { field: "form_8a_image", header: "Form 8A" },
  { field: "aadhar_card_image", header: "Aadhar Card" },
];